import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractMeta, DetailContractMeta } from '../helper/page-metadata';
import { ContractComponent } from './components/contract/contract.component';
import { ValidTokenGuard } from '../dave-data-module/guards/valid-token.guard';
import { TokenResolver } from '../dave-data-module/guards/token.resolver';
import { ContractResolver } from '../dave-data-module/guards/mdqx/contract.resolver';
import { ContractGroupTypeResolver } from '../dave-data-module/guards/mdqx/contract-group-type.resolver';
import { ContractStatusResolver } from '../dave-data-module/guards/mdqx/contract-status.resolver';
import { TEGueltigkeitResolver } from '../dave-data-module/guards/mdqx/te-gueltigkeit.resolver';
import { NewContractComponent } from './components/contract/new-contract/new-contract.component';
import { DetailContractComponent } from './components/contract/detail-contract/detail-contract.component';
import { ContractOptionsResolver } from '../dave-data-module/guards/mdqx/contract-options.resolver';
import { CustomerResolver } from '../dave-data-module/guards/customer.resolver';
import { CustomerTypeResolver } from '../dave-data-module/guards/customer-type.resolver';
import { ContractParticipantResolver } from '../dave-data-module/guards/mdqx/contract-participant.resolver';
import { FileResolver } from 'codelyzer/angular/fileResolver/fileResolver';

const routes: Routes = [
    {
        path: '',
        data: {breadcrumb: ContractMeta.Breadcrumb, breadcrumbIcon: ContractMeta.Icon},
        component: ContractComponent,
        canActivate: [ValidTokenGuard],
        canActivateChild: [ValidTokenGuard],
        resolve: {
            token: TokenResolver,
            contracts: ContractResolver,
            contractGroupTypes: ContractGroupTypeResolver,
            contractStatus: ContractStatusResolver,
            teGueltigkeit: TEGueltigkeitResolver
        },
        children: [
            {
                path: 'neuerVertrag',
                data: {breadcrumb: 'Neuer Vertrag'},
                component: NewContractComponent
            },
            {
                path: ':contractId',
                data: {breadcrumb: DetailContractMeta.Breadcrumb},
                component: DetailContractComponent,
                resolve: {
                    contracts: ContractResolver,
                    contractOptions: ContractOptionsResolver,
                    contractGroupTypes: ContractGroupTypeResolver,
                    contractStatus: ContractStatusResolver,
                    teGueltigkeit: TEGueltigkeitResolver,
                    customers: CustomerResolver,
                    contractParticipant: ContractParticipantResolver,
                    customerTypes: CustomerTypeResolver,
                }
            },
        ]
    },

];
@NgModule({
    imports: [RouterModule.forChild(routes)],
})
export class MdqxContractsRoutingModule { }
